import PrivacyPolicy from '@/components/PrivacyPolicy';
import Footer from '@/components/Footer';

export default function PrivacyPolicyPage() {
  return (
    <div className="pt-20">
      <PrivacyPolicy />
      <Footer />
    </div>
  );
}
